module.exports = __webpack_public_path__ + "static/media/GOTHIC.cfce6abb.TTF";